/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Days_Fixed_Days_TrimmedInputs */

const en_us2_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 fixed day no longer fits and was cleared`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 fixed day no longer fits and was cleared`);
	return /** @type {LocalizedString} */ (`${i?.count} fixed days no longer fit and were cleared`)
	
};

const pt_br2_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia fixo não cabe mais e foi desmarcado`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 dia fixo não cabe mais e foi desmarcado`);
	return /** @type {LocalizedString} */ (`${i?.count} dias fixos não cabem mais e foram desmarcados`)
	
};

const es_419_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 día fijo ya no cabe y se desmarcó`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 día fijo ya no cabe y se desmarcó`);
	return /** @type {LocalizedString} */ (`${i?.count} días fijos ya no caben y se desmarcaron`)
	
};

const pt_pt2_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 dia fixo já não cabe e foi desmarcado`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 dia fixo já não cabe e foi desmarcado`);
	return /** @type {LocalizedString} */ (`${i?.count} dias fixos já não cabem e foram desmarcados`)
	
};

const fr_fr2_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 jour fixe ne rentre plus et a été décoché`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 jour fixe ne rentre plus et a été décoché`);
	return /** @type {LocalizedString} */ (`${i?.count} jours fixes ne rentrent plus et ont été décochés`)
	
};

const de_de2_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 fester Tag passt nicht mehr und wurde abgewählt`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 fester Tag passt nicht mehr und wurde abgewählt`);
	return /** @type {LocalizedString} */ (`${i?.count} feste Tage passen nicht mehr und wurden abgewählt`)
	
};

const it_it2_days_fixed_days_trimmed = /** @type {(inputs: Days_Fixed_Days_TrimmedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 giorno fisso non rientra più ed è stato tolto`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 giorno fisso non rientra più ed è stato tolto`);
	return /** @type {LocalizedString} */ (`${i?.count} giorni fissi non rientrano più e sono stati tolti`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 fixed day no longer fits and was cleared" |
* | "-1" | "1 fixed day no longer fits and was cleared" |
* | * | "{count} fixed days no longer fit and were cleared" |
*
* @param {Days_Fixed_Days_TrimmedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const days_fixed_days_trimmed = /** @type {((inputs: Days_Fixed_Days_TrimmedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Days_Fixed_Days_TrimmedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_days_fixed_days_trimmed(inputs)
	if (locale === "es-419") return es_419_days_fixed_days_trimmed(inputs)
	if (locale === "pt-PT") return pt_pt2_days_fixed_days_trimmed(inputs)
	if (locale === "fr-FR") return fr_fr2_days_fixed_days_trimmed(inputs)
	if (locale === "de-DE") return de_de2_days_fixed_days_trimmed(inputs)
	if (locale === "it-IT") return it_it2_days_fixed_days_trimmed(inputs)
	return en_us2_days_fixed_days_trimmed(inputs)
});
export { days_fixed_days_trimmed as "days.fixed_days_trimmed" }